import React from 'react';
const ErrorContext = React.createContext();
export default ErrorContext;